import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-virtualized/styles.css";

ReactDOM.render(<App />, document.getElementById("root"));
